import * as Dialog from '@radix-ui/react-dialog';
import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';

import type { ComponentProps } from '~/chords/ComponentProps';
import { getClassNameOverride } from '~/chords/getClassNameOverride';
import { Scrollbars } from '~/chords/Scrollbars';
import { cn } from '~/lib/cn';

interface SlideOutBodyProps
  extends Omit<
    Dialog.DialogDescriptionProps &
      ComponentProps<HTMLAttributes<HTMLDivElement>>,
    'className'
  > {
  children: ReactNode;
}

export const SlideOutBody = forwardRef<HTMLDivElement, SlideOutBodyProps>(
  ({ children, ...props }, ref) => {
    const className = getClassNameOverride(props, 'SlideOut.Body');

    return (
      <Dialog.Description ref={ref} {...props} asChild>
        <Scrollbars asChild>
          <div
            className={cn(
              'h-full grow overflow-y-auto overscroll-y-contain px-lg py-md',
              className,
            )}
          >
            {children}
          </div>
        </Scrollbars>
      </Dialog.Description>
    );
  },
);

SlideOutBody.displayName = 'SlideOut.Body';
